import { logger } from "../utils/logger";

class MediaService {
  private tracks: Record<string, MediaStreamTrack> = {};

  private async getAudioTracks(deviceId?: string): Promise<MediaStreamTrack[]> {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: deviceId ? { deviceId: { exact: deviceId } } : true,
    });
    return stream.getAudioTracks();
  }

  private async getVideoTracks(deviceId?: string): Promise<MediaStreamTrack[]> {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: deviceId ? { deviceId: { exact: deviceId } } : true,
    });
    return stream.getVideoTracks();
  }

  public async getMicrophoneTrack(deviceId?: string): Promise<MediaStreamTrack | undefined> {
    try {
      const tracks = await this.getAudioTracks(deviceId);
      const track = tracks[0];
      if (track) {
        return this.setTrack(track);
      }
    } catch (error) {
      logger.warn("Failed to get audio tracks", error);
    }
    return undefined;
  }

  public async getCameraTrack(deviceId?: string): Promise<MediaStreamTrack | undefined> {
    try {
      const tracks = await this.getVideoTracks(deviceId);
      const track = tracks[0];
      if (track) {
        return this.setTrack(track);
      }
    } catch (error) {
      logger.warn("Failed to get video tracks", error);
    }
    return undefined;
  }

  public setTrack(track: MediaStreamTrack) {
    this.tracks[track.id] = track;
    return track;
  }

  public getTrack(trackId?: string): MediaStreamTrack | undefined {
    return trackId ? this.tracks[trackId] : undefined;
  }

  public stopAllTracks() {
    Object.values(this.tracks).forEach((track) => track.stop());
  }
}

export type { MediaService };
export const mediaService = new MediaService();
